import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { AuthorityBar } from './components/AuthorityBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductPresentation } from './components/ProductPresentation';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { testimonialsBatchOne, testimonialsBatchTwo, testimonialsBatchTwoTitle } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper pb-[68px] font-sans text-ink selection:bg-sage selection:text-ink md:pb-0" data-id="element-0" data-mp="3mlavz2zp87rv">
      <MetaPixel data-id="element-1" data-mp="3rdaqgfx028h2" />

      <main data-id="element-2" data-mp="3rcsy3udgkeef">
        <Hero data-id="element-3" data-mp="3rd191gq0t9mz" />
        <AuthorityBar data-id="element-4" data-mp="3relu8fqg3g86" />
        <Testimonials testimonials={testimonialsBatchOne} background="white" data-id="element-5" data-mp="5opiv1o0k3w" />
        <PainGrid data-id="element-6" data-mp="7sxbo2oq39g" />
        <BigIdea data-id="element-7" data-mp="2zld43f9knpe6" />
        <ProductPresentation data-id="element-8" data-mp="2zlv32jnmchps" />
        <Volumes data-id="element-9" data-mp="2zmwi0z7r9ocs" />
        <Bonuses data-id="element-10" data-mp="2zng14j956ise" />
        <Urgency data-id="element-11" data-mp="33mf3bw3ho1g5" />
        <Pricing data-id="element-12" data-mp="33lwy49yumcw3" />
        <Transformation data-id="element-13" data-mp="33ngf62sbwryx" />
        <Testimonials testimonials={testimonialsBatchTwo} title={testimonialsBatchTwoTitle} background="paper" data-id="element-14" data-mp="33myix65o2dr0" />
        <Guarantee data-id="element-15" data-mp="3dl4mrtb19tyi" />
        <Faq data-id="element-16" data-mp="3dlnu6g324zya" />
        <CostOfInaction data-id="element-17" data-mp="3dmfn1j59sjkv" />
        <Close data-id="element-18" data-mp="3dii5h1ycc033" />
      </main>

      <Footer data-id="element-19" data-mp="nw2bq4xkjoqk" />
      <StickyCta data-id="element-20" data-mp="nuhh6fb985sp" />
    </div>;
}